import { render, staticRenderFns } from "./top-artists.vue?vue&type=template&id=3ba28c66&scoped=true"
import script from "./top-artists.vue?vue&type=script&lang=ts"
export * from "./top-artists.vue?vue&type=script&lang=ts"
import style0 from "./top-artists.vue?vue&type=style&index=0&id=3ba28c66&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ba28c66",
  null
  
)

export default component.exports